export default "__VITE_ASSET__BwSCfwnP__"